import { AttemptSaveProvider } from './features/history/save';
import type { Tracker } from '@dcs/platform/track';
import { useState } from 'react';
import { RouterProvider, type DataRouter } from 'react-router';
import type { Ports } from './shared/lib/ports';
import { createWebPorts } from './shared/lib/web-ports';
import { AuthProvider, ErrorBoundary, PortsProvider, QueryProvider } from './shared/providers';
import { TrackProvider, createLazyTracker } from './shared/track';

interface AppProps {
  router: DataRouter;
  /** Defaults to the browser adapters; tests pass fakes. */
  ports?: Ports;
  /** Anonymous usage tracker; defaults to the browser one (built on the first event). */
  tracker?: Tracker;
}

/** Providers order (plan 2.4): ErrorBoundary > Ports > Track > Query > Auth > AttemptSave > Router. */
export function App({ router, ports, tracker }: AppProps) {
  const [resolved] = useState(() => ports ?? createWebPorts());
  const [usage] = useState(() => tracker ?? createLazyTracker());
  return (
    <ErrorBoundary reporter={resolved.errorReporter}>
      <PortsProvider ports={resolved}>
        <TrackProvider tracker={usage}>
          <QueryProvider>
            <AuthProvider>
              <AttemptSaveProvider>
                <RouterProvider router={router} />
              </AttemptSaveProvider>
            </AuthProvider>
          </QueryProvider>
        </TrackProvider>
      </PortsProvider>
    </ErrorBoundary>
  );
}
